import { ArrowRight, CalendarCheck } from "lucide-react";
import { company, stats, showHeroStats } from "@/mocks/home";
import HeroImage from "@/pages/home/components/HeroImage";
import HeroGreeting from "@/pages/home/components/HeroGreeting";

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[100svh] w-full items-center overflow-hidden">
      <HeroImage />
      <HeroGreeting />

      <div className="relative z-10 mx-auto w-full max-w-container px-4 pb-16 pt-[11rem] md:px-6 md:pb-20 md:pt-32 lg:px-10">
        <div className="max-w-3xl">
          <span className="inline-flex animate-fade-up items-center gap-2 rounded-full border border-primary-300/30 bg-background-50/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-200 backdrop-blur-sm">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-accent-400" />
            Gestão de condomínios em Vila Nova de Famalicão
          </span>

          <h1 className="mt-6 animate-fade-up font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-background-50 md:text-5xl lg:text-6xl" style={{ animationDelay: "80ms" }}>
            Gestão de condomínios com{" "}
            <span className="text-primary-300">transparência</span> e tranquilidade garantida.
          </h1>

          <p className="mt-6 max-w-2xl animate-fade-up text-base leading-relaxed text-background-200 md:text-lg" style={{ animationDelay: "160ms" }}>
            Na {company.shortName} cuidamos do seu edifício como se fosse nosso — administração financeira sem surpresas,
            comunicação clara e um acompanhamento próximo, com rosto humano.
          </p>

          <div className="mt-9 flex animate-fade-up flex-col gap-3 sm:flex-row sm:items-center" style={{ animationDelay: "240ms" }}>
            <a
              href="#reunioes"
              className="group inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-all duration-300 hover:scale-[1.03] hover:bg-primary-400 dark:text-foreground-950"
            >
              <CalendarCheck className="h-4 w-4" />
              Agendar Reunião
            </a>
            <a
              href="#servicos"
              className="group inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/5 px-7 py-3.5 text-sm font-semibold text-background-50 backdrop-blur-sm transition-all duration-300 hover:border-background-50/60 hover:bg-background-50/15"
            >
              Os Nossos Serviços
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>
        </div>

        {/* NÚMEROS DE DESTAQUE (ocultos de momento — empresa nova, sem histórico real).
            Para voltar a ativar mais tarde, basta pôr `showHeroStats` como `true` em src/mocks/home.ts. */}
        {showHeroStats && (
          <div className="mt-14 grid max-w-3xl grid-cols-2 gap-x-6 gap-y-6 border-t border-background-50/15 pt-8 md:grid-cols-4 md:gap-8">
            {stats.map((stat) => (
              <div key={stat.label}>
                <div className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{stat.value}</div>
                <div className="mt-1 text-xs font-medium uppercase tracking-wide text-background-300 md:text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}